import widgetTemplate from './hs-widget.html';
import * as helpers from '../shared/helpers';
import { bootstrapStyle } from '../shared/styles';
import { library, dom } from '@fortawesome/fontawesome-svg-core'
import { all } from '@awesome.me/kit-bd5fe14630/icons'

class HomeSearchWidget extends HTMLElement {
  constructor() {
    super();
    this.attachShadow({ mode: 'open' });

    const style = document.createElement('style');
    style.textContent = bootstrapStyle;
    this.shadowRoot.appendChild(style);

    const template = document.createElement('section');
    template.classList.add('ha-widget');
    template.innerHTML = widgetTemplate;
    this.shadowRoot.appendChild(template);

    library.add(...all);
    dom.watch({
      autoReplaceSvgRoot: this.shadowRoot,
      observeMutationsRoot: this.shadowRoot
    });
  }

  connectedCallback() {
    this.baseUrl = helpers.getBaseUrl();
    this.baseApiUrl = helpers.getBaseApiUrl();
    this.primaryColor = this.getAttribute('primary-color') || '#024267';
    this.secondaryColor = this.getAttribute('secondary-color') || '#F79322';
    this.widgetBackground = this.getAttribute('background-color') || 'transparent';
    this.fontFamily = this.getAttribute('font-family') || '"Helvetica Neue", Helvetica, Arial, sans-serif'
    this.fontUrl = this.getAttribute('font-url') || '';
    this.showOverlay = this.getAttribute('show-overlay') || 'no';
    this.primaryErrorText = this.getAttribute('primary-error-text') || 'No automated valuation could be generated for:';
    this.secondaryErrorText = this.getAttribute('secondary-error-text') || 'Want a professional estimate from an agent in the area?';
    this.errorPhone = this.getAttribute('error-phone') || null;
    this.errorEmail = this.getAttribute('error-email') || 'service@homeadvantage.com';
    this.init();
  }

  init() {
    helpers.setColors(this);
    this.setupSearchInput();
  }

  setupSearchInput() {
    const searchInput = this.shadowRoot.getElementById('search-input');
    const searchGroup = this.shadowRoot.getElementById('wrapper');
    const showOverlay = this.showOverlay.toLowerCase() === 'yes';

    if (showOverlay) {
      const overlay = this.shadowRoot.querySelector('.ha-overlay');
      overlay.style.width = '100%';
      overlay.style.padding = '4em';
      overlay.style.backgroundColor = this.getAttribute('overlay-background') || this.primaryColor;

      const overlayHeading = this.getAttribute('overlay-heading');
      if (overlayHeading) {
        const heading = document.createElement('h1');
        heading.classList.add('text-white');
        heading.innerHTML = overlayHeading;
        searchGroup.parentElement.insertBefore(heading, searchGroup);
      }

      const overlaySubHeading = this.getAttribute('overlay-sub-heading');
      if (overlaySubHeading) {
        const subHeading = document.createElement('h6');
        subHeading.classList.add('text-white');;
        subHeading.innerHTML = overlaySubHeading;
        searchGroup.parentElement.insertBefore(subHeading, searchGroup);
      }
    }

    const placeholder = this.getAttribute('text-placeholder') || 'Search by City, Zip, Neighborhood...';
    searchInput.setAttribute('placeholder', placeholder);

    let timeoutId;
    let abortController = new AbortController();

    searchInput.addEventListener('input', (e) => {
      const inputValue = e.target.value.toLowerCase();
      helpers.closeAllLists(this);

      if (inputValue.length < 3) {
        return false;
      }

      const spinner = this.shadowRoot.querySelector('.searching');
      spinner.classList.remove('d-none');

      abortController.abort();
      abortController = new AbortController();

      clearTimeout(timeoutId);
      timeoutId = setTimeout(() => {
        this.getArea(inputValue, abortController.signal, searchInput);
      }, 300);
    });
  }

  async getArea(text, signal, searchInput) {
    const endpoint = 'api/services/app/HomeSearch/GetSearchArea';
    const queryParams = { input: text };
    const url = `${this.baseApiUrl}${endpoint}?${helpers.serializeParams(queryParams)}`;

    try {
      const response = await fetch(url, { signal, headers: helpers.getHeaders() });
      if (!response.ok) {
        throw new Error('Network response was not ok');
      }

      const data = await response.json();
      const autocompleteItems = this.shadowRoot.getElementById('autocomplete-items');
      autocompleteItems.style.display = 'block';

      data.result.areas.forEach(suggestion => {
        const listItem = document.createElement('li');
        listItem.innerHTML = suggestion.label;
        listItem.addEventListener('click', () => {
          searchInput.value = suggestion.label;
          helpers.closeAllLists(this);
          window.open('https://search.myhomeadvantage.com/' + helpers.getTenantId() + "/" + searchInput.value.replace(/[^0-9a-zA-Z]+/g, "-"), "_blank");
        });
        autocompleteItems.appendChild(listItem);

        const spinner = this.shadowRoot.querySelector('.searching');
        spinner.classList.add('d-none');
      });
    } catch (error) {
      console.error('Fetch error:', error);
    }
  }

}

if (!customElements.get('home-search-widget')) {
  customElements.define('home-search-widget', HomeSearchWidget);
}

export default HomeSearchWidget;